import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { HiArrowRight } from "react-icons/hi";
import { MdEmail, MdLock } from "react-icons/md";
import "../../../assets/css/seller/auth/SellerSignUp.css";
import axios from "axios";
import TermsModal from "../../../components/seller/termsModal/TermsModal.js";
import AppContext from "../../../contexts/AppContext.js";
import LoadingScreen from "../../../components/general/animations/Animations.js";
import { Link } from "react-router-dom";

const SellerSignUp = () => {
  const navigate = useNavigate();
  const { baseUrl, regExpChecker, setSellerToken, setSeller } =
    useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    terms: "",
  });

  const togglePassword = () => setShowPassword(!showPassword);
  const toggleConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const Signupseller = () => {
    if (!agreeTerms) {
      setSignupLoading(false);
      setErrors((prev) => ({
        ...prev,
        terms: "Please agree to the Terms & Conditions to continue.",
      }));
      return;
    }

    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);
    formdata.append("confirmpassword", confirmPassword);

    axios
      .post(`${baseUrl}/seller/signup`, formdata, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setSignupLoading(false);
        if (response.data.success) {
          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify({
              ...response.data.seller,
              password: password,
            }),
          );
          setSellerToken(response.data.token);
          navigate("/seller/dashboard");
          setSeller(response.data.seller);
        }
      })
      .catch((error) => {
        console.log(error);
        setSignupLoading(false);
      });
  };

  if (signupLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="seller-glassmorphism-signup-container">
      <div className="seller-background-circles">
        <div className="seller-circle seller-circle-1"></div>
        <div className="seller-circle seller-circle-2"></div>
        <div className="seller-circle seller-circle-3"></div>
        <div className="seller-circle seller-circle-4"></div>
      </div>

      {/* NOTE: className renamed from "seller-content-wrapper" to
          "seller-signup-page-wrapper" to avoid a collision with
          .seller-content-wrapper defined globally in
          SellerMasterLayout.css (which sets background: #ffffff
          and was causing the white background bug on this page). */}
      <Container fluid className="seller-signup-page-wrapper">
        <Row className="seller-row w-100 g-0 align-items-center">
          <Col xl={6} lg={6} md={12} xs={12} className="seller-brand-section">
            <div className="seller-logo-container">
              <h1 className="seller-logo-text">CRAFTHIVE</h1>
              <p className="seller-logo-subtitle">Seller Portal</p>
            </div>
            <h2 className="seller-main-heading">
              Grow Your Craft Business Today
            </h2>
            <p className="seller-description-text">
              Turn your craft into a thriving business. CraftHive connects
              makers with buyers who love handmade work. Start selling yours
              with CraftHive today.
            </p>
          </Col>
          <Col xl={6} lg={6} md={12} xs={12} className="seller-form-section">
            <div className="seller-glass-card">
              <h3 className="seller-form-title">START SELLING TODAY</h3>
              <p className="seller-form-subtitle">Create your seller account</p>
              <Form className="seller-form">
                <Form.Group className="seller-input-group-custom">
                  <div className="seller-input-icon">
                    <MdEmail size={18} />
                  </div>
                  <Form.Control
                    type="email"
                    placeholder="Email Address"
                    className="seller-glass-input"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors((prev) => ({
                        ...prev,
                        email: regExpChecker("email", e.target.value),
                      }));
                    }}
                  />
                  {errors.email && (
                    <div className="text-danger mt-1 seller-error-text">
                      {errors.email}
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="seller-input-group-custom">
                  <div className="seller-input-icon">
                    <MdLock size={18} />
                  </div>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className="seller-glass-input"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrors((prev) => ({
                        ...prev,
                        password: regExpChecker("password", e.target.value),
                      }));
                    }}
                  />
                  {errors.password && (
                    <div className="text-danger mt-1 seller-error-text">
                      {errors.password}
                    </div>
                  )}
                  <div
                    className="seller-password-toggle"
                    onClick={togglePassword}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible size={20} />
                    ) : (
                      <AiOutlineEye size={20} />
                    )}
                  </div>
                </Form.Group>

                <Form.Group className="seller-input-group-custom">
                  <div className="seller-input-icon">
                    <MdLock size={18} />
                  </div>
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    className="seller-glass-input"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setErrors((prev) => ({
                        ...prev,
                        confirmPassword: regExpChecker("confirmPassword", {
                          password,
                          confirmPassword: e.target.value,
                        }),
                      }));
                    }}
                  />
                  {errors.confirmPassword && (
                    <div className="text-danger mt-1 seller-error-text">
                      {errors.confirmPassword}
                    </div>
                  )}
                  <div
                    className="seller-password-toggle"
                    onClick={toggleConfirmPassword}
                  >
                    {showConfirmPassword ? (
                      <AiOutlineEyeInvisible size={20} />
                    ) : (
                      <AiOutlineEye size={20} />
                    )}
                  </div>
                </Form.Group>

                <Form.Group className="seller-terms-group">
                  <Form.Check
                    type="checkbox"
                    id="agreeSellerTerms"
                    className="seller-terms-label"
                  >
                    <Form.Check.Input
                      type="checkbox"
                      name="agreeTerms"
                      className="seller-terms-checkbox"
                      checked={agreeTerms}
                      onChange={(e) => {
                        setAgreeTerms(e.target.checked);
                        setErrors((prev) => ({ ...prev, terms: "" }));
                      }}
                    />
                    <Form.Check.Label className="seller-terms-text">
                      I agree to the{" "}
                      <a
                        href="#terms"
                        className="seller-terms-link"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowTermsModal(true);
                        }}
                      >
                        Terms & Conditions
                      </a>
                    </Form.Check.Label>
                  </Form.Check>
                  {errors.terms && (
                    <div className="text-danger mt-1 seller-error-text">
                      {errors.terms}
                    </div>
                  )}
                </Form.Group>

                <Button
                  type="button"
                  className="seller-signup-button"
                  disabled={signupLoading}
                  onClick={() => {
                    if (!agreeTerms) {
                      setErrors((prev) => ({
                        ...prev,
                        terms:
                          "Please agree to the Terms & Conditions to continue.",
                      }));
                      return;
                    }
                    setSignupLoading(true);
                    Signupseller();
                  }}
                >
                  {signupLoading ? "SIGNING UP..." : "CREATE SELLER ACCOUNT"}
                  <HiArrowRight size={18} />
                </Button>
              </Form>

              <p className="seller-login-link-text">
                Already have a seller account?{" "}
                <Link to="/seller/login" className="seller-login-link">
                  Login
                </Link>
              </p>
            </div>
          </Col>
                </Row>
      </Container>

      <TermsModal
        show={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
    </div>
  );
};

export default SellerSignUp;